/* eslint-disable no-restricted-globals */
import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {
  withStyles,
  Tooltip,
  Fab,
  CircularProgress,
  Typography,
  // Grid,
} from '@material-ui/core'
import { Add } from '@material-ui/icons'
import Paper from 'components/theme/Paper'
import MaterialTable from 'material-table'
import classNames from 'classnames'
import { REQUEST, SUCCESS } from '../../utils/statusConstants'
import { deleteEntity, list /* , read  */ } from 'actions/data'
import language from 'utils/vast-languagepack'
import Icon from '@mdi/react'
import { mdiPlus } from '@mdi/js'
import { toggleDeleteDialog } from 'actions/view'

const mapStateToProps = (state) => ({
  campaigns: state.data.campaign,
  loadStatus: state.loadStatus.campaigns,
})

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    { deleteEntity, list, toggleDeleteDialog },
    dispatch,
  )
}

const styles = (theme) => ({
  button: {
    margin: theme.spacing.unit,
  },
  floatingActionButton: {
    position: 'fixed',
    bottom: '23px',
    right: '23px',
    color: '#fff',
  },
  main: {
    [theme.breakpoints.down('sm')]: {
      width: '100vw',
      padding: 12,
    },
  },
})

class CampaignsPage extends Component {
  componentDidMount() {
    if (!this.props.loadStatus) {
      this.props.list('campaign')
    }
  }

  render() {
    const { campaigns, classes, loadStatus } = this.props

    this.confirmDelete = function (d) {
      return window.confirm(d)
    }

    return (
      <div className={classes.main}>
        {loadStatus === SUCCESS ? (
          <MaterialTable
            columns={[
              { title: language.campaign.labels.name, field: 'name' },
              {
                title: language.campaign.labels.dateCreated,
                field: 'when_created',
                // customSort: (a, b) => new Date(a) - new Date(b),
                type: 'datetime',
              },
            ]}
            data={Object.values(campaigns)}
            title={language.campaign.labels.campaigns}
            options={{
              pageSize: 10,
              pageSizeOptions: [10, 25, 50, 100],
              actionsColumnIndex: -1,
            }}
            actions={[
              {
                icon: 'edit',
                tooltip: language.campaign.labels.editCampaign,
                onClick: (event, rowData) => {
                  // this.props.read(rowData.id, 'campaign')
                  this.props.history.push(`/campaigns/${rowData.id}`)
                },
              },
              (rowData) => ({
                icon: 'delete',
                tooltip: language.campaign.labels.deleteCampaign,
                onClick: (event, rowData) => {
                  // this.confirmDelete(`Confirm deleting: ${rowData.name}`) &&
                  //   this.props.deleteEntity(rowData.id, 'campaign');
                  this.props.toggleDeleteDialog({
                    ...rowData,
                    entityType: 'campaign',
                  })
                },
              }),
            ]}
            components={{
              Container: (props) => (
                <Paper>
                  <div {...props} />
                </Paper>
              ),
            }}
          />
        ) : loadStatus === REQUEST || loadStatus === null ? (
          <CircularProgress className={classes.progress} color="secondary" />
        ) : (
          <Typography variant="h2" gutterBottom>
            {language.campaign.helperText.noResults}
            <div
              style={{
                textAlign: 'center',
                fontSize: '20px',
                backgroundColor: '#014c94',
                color: '#ffffff',
                padding: '1%',
                maxWidth: '300px',
                borderRadius: '20px',
                margin: '40px auto 0 auto',
                border: '1px solid black',
                cursor: 'pointer',
                boxShadow:
                  '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 5px 8px 0px rgba(0,0,0,0.14), 0px 1px 14px 0px rgba(0,0,0,0.12)',
              }}
              onClick={() => this.props.history.push('/campaigns/new')}
            >
              <Icon path={mdiPlus} size={4} color="white" />
              <br />
              {language.campaign.helperText.createCampaign}
            </div>
          </Typography>
        )}
        <Tooltip
          title={language.campaign.helperText.createCampaign}
          placement="left"
        >
          <Fab
            color="secondary"
            aria-label="Add"
            className={classNames(classes.button, classes.floatingActionButton)}
            onClick={() => this.props.history.push('/campaigns/new')}
          >
            <Add />
          </Fab>
        </Tooltip>
      </div>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(CampaignsPage))
